export const storageKeys = {
  BINOCULAR_V1_SETTINGS: 'BINOCULAR_V1_SETTINGS',
  BINOCULAR_V2_SETTINGS: 'BINOCULAR_V2_SETTINGS',
  BINOCULAR_V3_SETTINGS: 'BINOCULAR_V3_SETTINGS',
  BINOCULAR_STEREOSCOPE_SETTINGS: 'BINOCULAR_STEREOSCOPE_SETTINGS',
  MEMORY_TASK_V2_SETTINGS: 'MEMORY_TASK_V2_SETTINGS',
  MEMORY_TASK_V2_MIXED_SIZES: 'MEMORY_TASK_V2_MIXED_SIZES',
}
